import { Injectable } from "@angular/core";
import { interval } from "rxjs";
import { IKeyboardShortcutListenerOptions } from "./CommonShortcutKeyInterface";
import { MatTableDataSource } from '@angular/material/table';
import { LocalStorageService } from "./LocalStorageService";


@Injectable()
export class Constant {

  isDecimalValue(value: any): boolean {
    // return (value != Math.floor(value));
    //Enable above return statement to working according to entered value, now not getting decimal allow or not from back-end
    return false;
  }

  removeZeroAndNullFromArray(value: any[]) {
    // let zeroIndex = value.findIndex(e => e == 0);
    // if (zeroIndex >= 0) {
    //   value.splice(zeroIndex, 1);M5092
    let nullIndex = value.findIndex(e => e == null);
    if (nullIndex >= 0) {
      value.splice(nullIndex, 1);
    }
    return value;
  }

  removeZero(value: any[]) {
    let zeroIndex = value.findIndex(e => e == 0);
    if (zeroIndex >= 0) {
      value.splice(zeroIndex, 1);
    }
    return value;
  }

  convertTimeTo24Format(time: string) {
    let formattedTime = time;
    if (time.length > 5) {
      formattedTime = time.substring(0, 5);
      if (formattedTime.substring(0, 2) != '00' && formattedTime.substring(0, 2) != "12") {
        if (time.substring(6) == 'pm') {
          formattedTime = (Number(formattedTime.substring(0, 2)) + 12) + formattedTime.substring(2, 5);
        }
      }
      else if (Number(formattedTime.substring(0, 2)) == 12 && (time.substring(6) == 'am')) {
        formattedTime = "00" + formattedTime.substring(2, 5);
      }
    }
    return formattedTime;
  }

  enableGlobalFilter<T>(dataSource: MatTableDataSource<T>) {
    dataSource.filterPredicate = (data: T, filter: string) =>
      JSON.stringify(data).toLowerCase().includes(filter);
  }

  activeUserStatuses: string[] = ['ACTIVE', 'UNSUSPENDED', 'PROVISIONED'];

  //Colors
  readonly COUPON_COLOR_CODES: string[] = ["#fe0000", "#8e3200", "#2f5989", "#e71f69", "#6d8b74", "#004aad"];

  //Back-end error codes
  readonly MISMATCH_IN_CALCULATION_ERROR_CODE = 'M5092'

  noofFCMMessages: number = 0;
  //Union Territories
  unionTerritoriesStateCodes: string[] = ["01", "04", "07", "25", "26", "31", "34", "35"];

  //Make To Order
  parentLocationName: string = '';

  //Master Employee
  readonly employeeTypeList: string[] = ["Part Time", "Full Time"];
  readonly bloodGroupList: string[] = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
  readonly genderList: string[] = ['Male', 'Female', 'Other'];
  readonly maritalStatusList: string[] = ['Married', 'Unmarried'];
  readonly educationList: string[] = ['10th', '12th', ' Graduate', 'Post Graduate'];
  readonly statusList: string[] = ['Active', 'Inactive'];
  readonly leadStagesList: string[] = ['Lead', 'Prospect', 'Opportunity', 'Proposal Send', 'Converted'];
  readonly sourceList: string[] = ["Email", "Whatsapp", "Website", "Referral", "Other"];
  readonly canStartList: string[] = ["In one month", "In two months", "In three months", "Others"];
  //MasterEmployee End

  readonly oktaApiKey = 'SSWS 00VqgMvXxG_CskjsgkYQBbvtX5H-_YjHFF23MxCMqT';
  readonly oktaDomain = 'https://dev-311930.okta.com';
  // readonly pageItemsSizeCommon: number = 9;
  readonly pageSizeCommon: number = 11;
  readonly pageSize10: number = 10;
  readonly pageSize09: number = 8;
  readonly cancelPageSizeCommon: number = 12;

  readonly pageSize12: number = 12;
  readonly pageSize13: number = 13;
  readonly pageSize14: number = 14;
  readonly pageSize15: number = 15;
  readonly pageSize16: number = 16;

  //for progress bar
  readonly progressBarColor = 'accent';
  readonly progressBarMode = 'indeterminate';
  readonly progressBarValue = 50;

  //PolicySetUp
  readonly fileBigSize: string = "10Mb Max File Size..";
  readonly maxCharacterSize: number = 50;
  readonly uploadFileSize: number = 10485760;//10mb to bytes
  readonly uploadQueryFileSize: number = 1e+6;
  readonly signUploadFileSize: number = 400000;
  readonly documentTypeList: string[] = ["Proof Of Id", "Proof Of Address"];
  readonly yesNoList: string[] = ["Yes", "No"];
  readonly reqTypeList: string[] = ["Mandatory", "Optional"];
  readonly letterTypeList: string[] = ["Company", "Employee", "Both"];
  readonly setUpStatusList: string[] = ["All", "Active", "Cancelled"];
  readonly ratingTypeList: string[] = ['Number', 'Rating', 'Star', 'Time'];
  readonly yesClicked: boolean = true;
  readonly issueStatusList: string[] = ["Approved", "Declined"];
  readonly appraisalStatus: string[] = ["Appraised"];
  readonly cancelStatus: string = "Are you want to cancel....?";
  readonly requestQuantity: string = "Request Quantity has reached it's MaxQuantity";

  //Appointment
  readonly appointmentType: string[] = ['Official', 'Personal'];
  readonly appointmentFixedBy: string[] = ['Self', 'Employee'];
  readonly defaultCompany = 1;
  readonly defaultCompanyName = "Mobitrix";

  //GatePass
  readonly modeOfPermission: string[] = ['Self', 'Phone'];

  //date formate
  readonly dateFormat: string = 'dd-MMM-yyyy';
  readonly timeFormat: string = 'hh:mm a';
  readonly timeFormat24: string = 'HH:mm';

  readonly dateFormat_DMY: string = 'DD-MMM-yyyy';
  readonly timeWithSecondsFormat: string = 'hh:mm:ss';
  readonly timeWithoutSecondsFormat: string = 'hh:mm';

  readonly dateTimeFormatForDBServer: string = "YYYY-MM-DD HH:mm:ss"
  readonly dateTimeFormatForDBServe: string = "YYYY-MM-DD 00:00:00"
  readonly dateFormatForDBServer: string = 'YYYY-MM-DD';
  readonly posTimeStamp: string = 'yyyy-MM-dd HH:mm:ss';


  readonly viewDateFormat_DMY: string = 'dd-MM-yyyy';
  readonly viewDateFormat_YMD: string = 'YYYY-MM-DD';
  readonly viewDateFormat_DMYHM: string = 'dd-MM-yyyy HH:mm';
  readonly viewDateFormat_DMYHMS: string = 'dd-MM-yyyy HH:mm:ss';
  readonly viewDateFormat_DMYTHMS: string = 'dd-MM-yyyyTHH:mm:ss';
  readonly viewDateFormat_YMDHMS: string = 'YYYY-MM-DD HH:mm:ss';

  readonly slashDateFormat_DMY: string = 'dd-MM-yyyy';
  readonly slashDateFormat_YMD: string = 'YYYY/MM/DD';
  readonly slashDateFormat_DMYHM: string = 'dd-MM-yyyy HH:mm';
  readonly slashDateFormat_DMYHMAM: string = 'dd-MM-yyyy, HH:mm a';
  readonly slashDateFormat_DMYHMS: string = 'dd-MM-yyyy HH:mm:ss';
  readonly slashDateFormat_YMDHMS: string = 'YYYY/MM/DD HH:mm:ss';

  //This format is used on view table date
  readonly dateFormatForView: string = 'yyyy-MM-dd';
  readonly dateFormatForViewInventory: string = 'YYYY-MM-DD';

  readonly fromDate: string = 'YYYY-MM-DD 00:00:00'
  readonly toDate: string = 'YYYY-MM-DD 23:59:59'

  //This format is uded on security
  readonly fromDateWithT: string = 'YYYY-MM-DDT00:00:00'
  readonly toDateWithT: string = 'YYYY-MM-DDT23:59:59'

  //Decimal format
  formattedDecimal: string = '1.2-2';

  //Inventory Id
  readonly capitalGoodsInvId: number = 1;
  readonly rawMaterialsInvId: number = 2;
  readonly semiFinishedGoodsInvId: number = 3;
  readonly finishedGoodsInvId: number = 4;
  readonly scrapInvId: number = 5;
  readonly tradeGoodsInvId: number = 6;
  readonly othersInvId: number = 7;

  readonly minCharForSearch: number = 3;
  readonly cashPaymentTypeForSale: string = "Receipt";

  addDisable: boolean = true;
  viewDisable: boolean = true;
  editDisable: boolean = true;
  deleteDisable: boolean = true;

  readonly intervalTimeForSearch = interval(2000);
  readonly intervalTimeOf30Seconds = interval(30000);
  readonly intervalTimeOfHalfSecond = interval(500);

  //WeekDays
  readonly weekDays = new Map([[0, 'Sunday'], [1, 'Monday'], [2, 'Tuesday'], [3, 'Wednesday'],
  [4, 'Thursday'], [5, 'Friday'], [6, 'Saturday']]);

  readonly DELIVERED: string = "Delivered";
  readonly DELIVERY_RESCHEDULE: string = "Re-Scheduled";
  readonly DELIVERY_CANCEL: string = "Delivery Cancelled";
  readonly DELIVERY_PICK_UP: string = "Picked-Up";
  readonly DELIVERY_PICK_UP_CANCELLED: string = "Pick-Up-Cancelled";
  readonly ASSIGNED: string = "Assigned";
  readonly RE_ASSIGNED: string = "Re-Assigned";
  readonly RIDER_ACCEPTED: string = "Rider Accepted";
  readonly RIDER_DECLINED: string = "Rider Declined";

  //WholeSale Approve B2B Customer
  readonly approveB2bCustomerMessage: string = 'Are You Want To Approve Customer';
  readonly rejectB2bCustomerMessage: string = 'Are You Want To Reject Customer';
  readonly rejectB2bCustomerAlertMessage: string = 'Please give reason to proceed.';

  // Approve-attendance Module
  readonly approveAttendanceMessage: string = 'Do you want to approve this attendance?';

  // Request Leave
  readonly approveLeaveMessage: string = 'Do you want to approve this leave?';
  readonly rejectLeaveMessage: string = 'Do you want to reject this leave?';

  //SubModule
  readonly manageProcessCode: number = 28;
  readonly scheduleProcessCode: number = 29;
  readonly executeProcessCode: number = 30;


  //Sub-Sub-Module internalNames
  readonly TAXABLE_DELIVERY_CHALLAN: string = "TaxableDeliveryChallan";
  readonly EXEMPTED_DELIVERY_CHALLAN: string = "ExemptedDeliveryChallan";
  readonly TAXABLE_RECEIPT_CHALLAN: string = "TaxableReceiptChallan";
  readonly EXEMPTED_RECEIPT_CHALLAN: string = "ExemptedReceiptChallan";
  readonly SALE_INVOICE: string = "SaleInvoice-Sale-Invoice-Sales";
  readonly BILL_OF_SUPPLY: string = "BillOfSupply-Sale-Invoice";
  readonly B2B: string = "B2BPurchaseInvoice";
  readonly B2BUR: string = "B2BUR";
  readonly PURCHASE_BILL_OF_SUPPLY: string = "PurchaseBillOfSupply-Purchase-Invoice";
  readonly PURCHASE_CDNR: string = "Cdnr-Purchase-Invoice";
  readonly PURCHASE_CDNUR: string = "CdnurPurchaseInvoice";
  readonly CREDIT_DEBIT_NOTE: string = "Credit-DebitNote-Sale-Invoice-Sales";

  readonly RO_SI_TO_PI: string = "Receive Order (SI to PI)";
  readonly RO_BOS_TO_PI: string = "Receive Order (BOS to PI)";
  readonly RO_SI_TO_BOS: string = "Receive Order (SI to BOS)";
  readonly RO_BOS_TO_BOS: string = "Receive Order (BOS to BOS)";
  readonly RO_TAXABLE_RECEIPT_CHALLAN: string = "Receive Order (Taxable Receipt Challan)";
  readonly RO_EXEMPTED_RECEIPT_CHALLAN: string = "Receive Order (Exempted Receipt Challan)";


  //Sub-Sub-Module page-urls
  readonly URL_POS: string = "sale/pos/pos";
  readonly URL_POS_WEBAPP: string = "sale/pos/pos-web-app";
  readonly URL_CASH_REGISTER: string = "sale/pos/cash-register";
  readonly URL_CASH_REGISTER_WEBAPP: string = "sale/pos/cash-register-web-app";
  readonly URL_MANAGE_BILL: string = "sale/pos/manage-bills";

  readonly URL_TAXABLE_DELIVERY_CHALLAN: string = "gst/delivery-challan/taxable-delivery-challan";
  readonly URL_EXEMPTED_DELIVERY_CHALLAN: string = "gst/delivery-challan/exempted-delivery-challan";
  readonly URL_TAXABLE_RECEIPT_CHALLAN: string = "gst/delivery-challan/taxable-receipt-challan";
  readonly URL_EXEMPTED_RECEIPT_CHALLAN: string = "gst/delivery-challan/exempted-receipt-challan";
  readonly URL_SALE_INVOICE: string = "sale/invoice/sale-invoice";
  readonly URL_BILL_OF_SUPPLY: string = "sale/invoice/bill-of-supply";
  readonly URL_CREDIT_DEBIT_NOTE: string = "sale/invoice/credit-or-debit-note";
  readonly URL_PURCHASE_B2B: string = "purchase/invoice/b2b";
  readonly URL_PURCHASE_B2BUR: string = "purchase/invoice/b2bur";
  readonly URL_PURCHASE_BILL_OF_SUPPLY: string = "purchase/invoice/purchase-bill-of-supply";
  readonly URL_PURCHASE_CDNR: string = "purchase/invoice/purchase-cdnr";
  readonly URL_PURCHASE_CDNUR: string = "purchase/invoice/purchase-cdnur";
  readonly URL_PURCHASE_ORDER: string = "purchase/invoice/purchase-order";

  readonly URL_PROFORMA_INVOICE: string = "sale/invoice/proforma-invoice";
  readonly URL_QUOTATION: string = "sale/invoice/quotation";

  readonly URL_PARTICIPANT: string = "crm/survey/participant";
  readonly URL_QUESTION: string = "crm/survey/questions";

  readonly URL_DASHBOARD: string = "dashboard";

  readonly URL_DISPATCH_FG: string = "order/dispatch/dispatchfinishedgoods";
  readonly URL_DISPATCH_SFG: string = "order/dispatch/dispatchsemifinished";
  readonly URL_DISPATCH_RM: string = "order/dispatch/dispatchrawmaterials";
  readonly URL_DISPATCH_CG: string = "order/dispatch/dispatchtcapitalgoods";
  readonly URL_DISPATCH_TG: string = "order/dispatch/dispatchtradegoods";
  readonly URL_DISPATCH_SCRAP: string = "order/dispatch/dispatchscrap";
  readonly URL_DISPATCH_OTHERS: string = "order/dispatch/dispatchothers";
  readonly URL_DISPATCH_MTO: string = "order/dispatch/dispatch-make-to-order";

  readonly URL_RECEIVE_FG: string = "order/receive/receivefinishedgoods";
  readonly URL_RECEIVE_SFG: string = "order/receive/receivesemifinishedgoods";
  readonly URL_RECEIVE_RM: string = "order/receive/receiverawmaterials";
  readonly URL_RECEIVE_CG: string = "order/receive/receivecapitalgoods";
  readonly URL_RECEIVE_TG: string = "order/receive/receivetradegoods";
  readonly URL_RECEIVE_SCRAP: string = "order/receive/receivescrap";
  readonly URL_RECEIVE_OTHERS: string = "order/receive/receiveothers";
  readonly URL_RECEIVE_MTO: string = "order/receive/receive-make-to-order";

  readonly URL_Return_FG: string = "order/return/goodsReturnFinishedGoods";
  readonly URL_Return_SFG: string = "order/return/goodsReturnSemiFinishedGoods";
  readonly URL_Return_RM: string = "order/return/goodsReturnRawMaterials";
  readonly URL_Return_CG: string = "order/return/goodsReturnCapitalGoods";
  readonly URL_Return_TG: string = "order/return/goodsReturnTradeGoods";
  readonly URL_Return_SCRAP: string = "order/return/goodsReturnScrap";
  readonly URL_Return_OTHERS: string = "order/return/goodsReturnOthers";
  readonly URL_Return_MTO: string = "order/return/return-make-to-order";

  readonly URL_RGR_FG: string = "order/receive-return/receivegoodsreturn-finishedgoods";
  readonly URL_RGR_SFG: string = "order/receive-return/receivegoodsreturn-semifinishedgoods";
  readonly URL_RGR_RM: string = "order/receive-return/receivegoodsreturn-rawmaterials";
  readonly URL_RGR_CG: string = "order/receive-return/receivegoodsreturn-capitalgoods";
  readonly URL_RGR_TG: string = "order/receive-return/receivegoodsreturn-tradegoods";
  readonly URL_RGR_SCRAP: string = "order/receive-return/receivegoodsreturn-scrapgoods";
  readonly URL_RGR_OTHERS: string = "order/receive-return/receivegoodsreturn-others";
  readonly URL_RGR_MTO: string = "order/receive-return/receive-return-make-to-order";

  readonly URL_VIEW_NOTIFICATION: string = "message-center/messaging/view-notification";
  readonly URL_MONITORING_DASHBOARD: string = "monitoring-dashboard";

  readonly URL_WEB_ORDER_CONFIRMATION: string = "shipping/shippings/web-order-confirmation";
  readonly URL_WEB_ORDER: string = "order/web-order/weborder";
  readonly URL_WEB_ORDER_REFUND: string = "account/refunds/refunds";

  readonly ORDER_DELIVERY: string = "shipping/shippings/manage-delivery";
  readonly URL_CUSTOMIZE_ORDER: string = "order/web-order/customized-orders";
  readonly RUPEES_SYMBOL: string = "₹";
  //ShortcutKey
  // createShortcut: IKeyboardShortcutListenerOptions = {
  //   description: 'craete',
  //   keyBinding: ['alt', 'n']
  // };
  // viewShortcut: IKeyboardShortcutListenerOptions = {
  //   description: 'view',
  //   keyBinding: ['alt', 'v']
  // };
  saveShortcut: IKeyboardShortcutListenerOptions = {
    description: 'save',
    keyBinding: ['alt+s']
  };
  parkShortcut: IKeyboardShortcutListenerOptions = {
    description: 'park',
    keyBinding: ['alt+k']
  };
  resetShortcut: IKeyboardShortcutListenerOptions = {
    description: 'reset',
    keyBinding: ['alt+r']
  };
  summaryShortcut: IKeyboardShortcutListenerOptions = {
    description: 'summary',
    keyBinding: ['alt+u']
  };
  autoOrderShortcut: IKeyboardShortcutListenerOptions = {
    description: 'autoorder',
    keyBinding: ['alt+o']
  };
  exportShortcut: IKeyboardShortcutListenerOptions = {
    description: 'export',
    keyBinding: ['alt+x']
  };
  viewbtnShortcut: IKeyboardShortcutListenerOptions = {
    description: 'viewbtn',
    keyBinding: ['alt+v']
  };
  paymentbtnShortcut: IKeyboardShortcutListenerOptions = {
    description: 'payment',
    keyBinding: ['alt+p']
  };
  ewaybillShortcut: IKeyboardShortcutListenerOptions = {
    description: 'ewaybill',
    keyBinding: ['alt+w']
  };
  // updateShortcut: IKeyboardShortcutListenerOptions = {
  //   description: 'update',
  //   keyBinding: ['alt', 'e']
  // };
  tablefilterShortcut: IKeyboardShortcutListenerOptions = {
    description: 'tablefilter',
    keyBinding: ['alt+i']
  };
  supplierbtnShortcut: IKeyboardShortcutListenerOptions = {
    description: 'supplierbtn',
    keyBinding: ['alt+l']
  };
  indentallmaterialsShortcut: IKeyboardShortcutListenerOptions = {
    description: 'indentallmaterials',
    keyBinding: ['alt+n']
  };
  continueShortcut: IKeyboardShortcutListenerOptions = {
    description: 'continue',
    keyBinding: ['alt+e']
  };
  customizedproductmtoShortcut: IKeyboardShortcutListenerOptions = {
    description: 'customizedproduct',
    keyBinding: ['alt+z']
  };
  deliveryaddressbtnShortcut: IKeyboardShortcutListenerOptions = {
    description: 'deliveryaddress',
    keyBinding: ['alt+d']
  };
  backbuttonShortcut: IKeyboardShortcutListenerOptions = {
    description: 'backbutton',
    keyBinding: ['alt+b']
  };
  selectcustomerShortcut: IKeyboardShortcutListenerOptions = {
    description: 'selectcustomer',
    keyBinding: ['alt+c']
  };
  // receiveShortcut: IKeyboardShortcutListenerOptions = {
  //   description: 'receive',
  //   keyBinding: ['alt', 'i']
  // };
  addShortcut: IKeyboardShortcutListenerOptions = {
    description: 'add',
    keyBinding: ['alt+a']
  };
  batchinvoicingShortcut: IKeyboardShortcutListenerOptions = {
    description: 'batchinvoicing',
    keyBinding: ['alt+g']
  };
  vehiclechoosebtnShortcut: IKeyboardShortcutListenerOptions = {
    description: 'vehicle',
    keyBinding: ['alt+h']
  };
  crateselectbtnShortcut: IKeyboardShortcutListenerOptions = {
    description: 'crate',
    keyBinding: ['alt+t']
  };
  calculatoropenShortcut: IKeyboardShortcutListenerOptions = {
    description: 'calculator',
    keyBinding: ['alt++']
  };
  dilogcloseShortcut: IKeyboardShortcutListenerOptions = {
    description: 'dilogclose',
    keyBinding: ['alt+Delete']
  };
  dilogsaveShortcut: IKeyboardShortcutListenerOptions = {
    description: 'dilogsave',
    keyBinding: ['alt+Enter']
  };


  readonly ACCOUNTS_PAY: string = "Accounts Pay";
  readonly ACCOUNTS_VOUCHER: string = "Accounts Voucher";
  readonly SHIPPING: string = "Shipping";
  readonly EXPENSES_VOUCHER: string = "Expenses";

  //All dialog message
  //HEADINGMESSAGE
  readonly resetDataHeadingMessage: string = "Do you wish to Proceed?"; //used in purchase
  readonly autoProcessDeleteHeadingMessage: string = "Are you sure want to Delete?";
  readonly appaddedHeadingMessage: string = "Confirm App update ? ";
  readonly updateHeadingMessage: string = "Please confirm if you want to update the changes.";
  readonly discountUpdateHeadingMessage: string = "Updating an offer shall create new offer. Existing offer shall become inactive.";

  readonly dispatchToStoreMessage: string = "Please confirm if you want to Dispatch order to the store.";
  readonly deliveryAtStoreMessage: string = "Please confirm if you want to deliver order to the store.";
  readonly PickupAtStoreMessage: string = "Please confirm if you want to deliver order to the customer.";

  readonly returnToParentMessage: string = "Please confirm if you want to return order to parent.";
  readonly returnReceiveAtParentMessage: string = "Please confirm if you want to return receive.";

  //SUBMESSAGE
  readonly SubMessage: string = "Do you wish to Proceed?";
  readonly autoProcessDeleteSubMessage: string = "Attention! This action will deactivate the auto processing of orders.";
  readonly clearAllSavedDataSubMessage: string = "Data Clear Confirmation: All saved data will be cleared.";
  readonly invoiceCancelSubMessage: string = "Cancel Transaction Alert: This action will cancel the transaction.";
  readonly receiveDeleteSubMessage: string = "Cancel Transaction Alert: This action will cancel the transaction.";

  //order
  readonly saveHeadingMessage: string = "Confirm transaction ?";
  readonly saveSubMessage: string = "Do you wish to Proceed?";
  readonly resetParkedDataHeadingMessage: string = "Reset Confirmation: Resetting will remove all items.";
  readonly resetDataAfterChangeLocHeadingMessage: string = "Reset Confirmation: Change in location will remove all items.";
  readonly resetParkedDataSubMessage: string = "Do you wish to Proceed?";
  readonly cancelHeadingMessage: string = "Are you sure want to Cancel?"; // Order
  readonly cancelSubMessage: string = "Cancelled";  //Order will be 
  readonly parkHeadingMessage: string = "Parking shall save all data. You can make changes later.";
  readonly parkSubMessage: string = "Do you wish to Proceed?";

  //receives
  readonly crateRecieveSaveHeadingMessage: string = "You are about to receive the order with ";
  readonly generateInvoiceHeadingMessage: string = "Are you sure you want to generate the invoice?";

  //POS 
  readonly cancelCashRegisterHeadingMessage: string = "Please note that reloading will not save any data.";
  readonly cancelCashRegisterSubMessage: string = "Do You Want To Proceed";

  readonly onPaymentClickHeadingMessage: string = "No modification is permitted after payment.";
  readonly onPaymentClickSubMessage: string = "Would you like to proceed";

  // readonly onParkClickForPOSHeadingMessage: string = " "Park " + this.orgName + " with " + this.dataSource.data.length + " items.";";
  readonly onParkClickForPOSSubMessage: string = "This action will save all your cart data.";
  readonly checkoutHeadingMessage: string = "Please confirm if you wish to checkout.";
  readonly resetCartHeadingMessage: string = "Reset Confirmation: Resetting will remove all items.";
  readonly resetCartSubMessage: string = "Reset Confirmation: Resetting will remove all items.";

  //sales(invoice)
  readonly resetHeadingMessage: string = "Reset Confirmation: Resetting will remove all items.";
  readonly saveSaleDataHeadingMessage: string = "Please confirm if you want to save the changes.";
  readonly deleteSaleDataHeadingMessage: string = "Cancel Transaction Alert: This action will cancel the transaction.";

  //dispatch
  readonly dispatchTypeClickHeadingMessage: string = "Changing \"Dispatch Type\" shall clear all data.";
  readonly dispatchTypeClickSubMessage: string = "Do you wish to Proceed?";
  readonly loadAutoOrderDataHeadingMessage: string = "Do you wish to load products by their rol and stock.";


  //RIder Details
  readonly approveRider: string = "Please confirm if you want to Approve the Rider.";
  readonly approveRiderConfirmation: string = "Rider Approved successful.";
  readonly rejectRider: string = "Please confirm if you want to Reject the Rider.";
  readonly rejectRiderConfirmation: string = "Rider Rejected successful.";



  readonly resolveCustomOrder: string = "Please confirm if you want to Resolve the Order.";
  readonly declineCustomOrder: string = "Please confirm if you want to Decline the Order.";

  readonly approveCustomOrderConfirmation: string = "CustomOrder Approved successfully.";
  readonly declineCustomOrderConfirmation: string = "CustomOrder Declined successfully.";

  readonly feedBackConfirmation: string = "Please select status & give reason to proceed.";
  readonly feedBackUpdateStatus: string = "Updated successfully.";

  readonly unfulfilledConfirmation: string = "Please select a reason to proceed.";

  //-----------Toast Message-------------

  readonly selectLocToFetchOffers: string = "Select a location to get offers.";
  readonly selectLocToFetchCouponProducts: string = "Select a location to get coupon products.";
  readonly selectLocToFetchAutoOrderProducts: string = "Select a location to get auto order products.";
  readonly invalidFormToast: string = "Oops! Invalid or No data found. Please try again.";
  // readonly noDataAvailableToast: string = "Sorry, no data available for the selected date range.";
  readonly noDataAvailableToast: string = "Sorry, no data available for the selected criteria.";
  readonly insufficientformData: string = "Please select all the required fields to get the data.";
  readonly dataNotAvailableToast: string = "Sorry, no data available.";
  readonly detailNotAvailableToast: string = "Sorry, detail data not available.";
  readonly detailsNotAvailableToast: string = "Sorry, details not available.";
  readonly notAllowedToast: string = "Access Denied! You are not allowed to perform this operation.";
  readonly serverSideErrorToast: string = "Oops! Server-side error occurred. Please try again later.";
  readonly cancelNotAllowedToast: string = "Cancellation beyond this date is not permitted. Please contact the administrator for further assistance.";
  readonly editNotAllowedToast: string = "Edit is not allowed beyond this date,Contact admin";
  readonly cancelInvoiceToast: string = "Return is not possible,Cancel the invoice instead";
  readonly ledgerExistToast: string = "This ledger already exists.";
  readonly zeroAmountToast: string = "Error! The amount cannot be zero. Please enter a valid amount.";
  readonly enterAmountToast: string = "Attention! Please enter amount.";
  readonly productQtyNotBeZeroToast: string = "Error: Quantity cannot be zero. Remove the item instead.";
  readonly productQtyMoreOrEqualToZeroToast: string = "Error: The quantity must be equal to or greater than the minimum order quantity.";
  readonly addToCartToast: string = "Reminder! Please add products to confirm.";
  readonly invalidFileToast: string = "Alert! Invalid file type. Select .csv(comma delimited)";
  readonly invalidDataToast: string = "Alert! Invalid Data";
  readonly selectLocationToast: string = "Alert: Select \"location\" to proceed.";
  readonly debitandCreditMismatchToast: string = "Mismatch found between total of debit and credit amounts. Please check and try again.";
  readonly importFailedToast: string = "Oops! Import process has failed. Please ensure that the file format and data are correct and try again.";
  readonly enterAmountandPayToast: string = "Attention! Please provide payer VA and amount.";
  readonly taxableItemNotPresentToast: string = "Alert! No taxable item found.";
  readonly maxDiscountExeedToast: string = "Max Discount Percentage Exceeded";
  readonly zeroRatedItemAllowedToast: string = "Alert! Only 0 rated items are allowed for this transaction.";
  readonly zeroRatedItemNotAllowedToast: string = "Zero-rated items are not allowed for this action";
  readonly zeroRatedItemNotPresentToast: string = "Alert! No 0 Rated Item found.";
  readonly somethingWrongToast: string = "Oops! Something went wrong.";
  readonly selectLedgerToast: string = "Attention! Set customer ledger in Billing Management for invoicing.";
  readonly fileUploadFailedToast: string = " File upload failed";
  readonly summryReportToast: string = "Reminder! Please add products to generate a summary report.";
  readonly cartEmptyToast: string = "Your shopping cart is currently empty. Add few products to proceed.";
  readonly processNotAvailableToast: string = "Alert! No process found";
  readonly fromDateToast: string = "Alert: Select \"from date\" to proceed.";
  readonly dateToast: string = "Alert: Select date to proceed.";
  readonly selectVehicleToast: string = "Alert: Add vehicle & driver to proceed.";
  readonly selectCrateToast: string = "Alert: Provide crate details to proceed.";
  readonly selectCrateNoToast: string = "Attention! Please provide crate number.";
  readonly selectReturnLocToast: string = "Alert: Select returning location  to proceed.";
  readonly confirmOrCancelPackedDataToast: string = "Unsaved records found. Confirm or cancel to proceed";
  readonly selectGoodsReturnNoToast: string = "Alert: Select \"Receive Goods Return Number\" to proceed.";
  readonly selectGoodReturnNoToast: string = "Alert: Select \"Goods Return Number\" to proceed.";
  readonly ifRequiredEditToast: string = "Please note that commas are not allowed in import mode. However, if you need to add commas, you can edit the master data, add the commas, and save the updated information.";
  readonly discountNotApplicableToast: string = " Discount not applicable on this product";
  readonly selectCompanyToast: string = "Alert: Select company to proceed.";
  readonly alreadyPresentToast: string = "Alert! This product is already present. Please choose a different one.";
  readonly toLocBlankToast: string = "Alert! Select a location to proceed.";
  readonly paymentFailedToast: string = "Sorry! Your payment has failed.";
  readonly billingLocNotEnableToast: string = "Sorry, billing for this location is currently not enabled.";
  readonly selectReasonToast: string = "Alert: Select a reason to proceed with your request.";
  readonly invalidReasonToast: string = "Please enter a valid reason for the return.";
  readonly provideAllValueToast: string = "Attention! Provide all the required values before proceeding.";
  readonly taxableselectIndentDeptToast: string = "Unable To Generate Invoice. No taxable product was found. ";
  readonly productqtyLotSizeToast: string = "Error: Product quantity cannot be less than the lot size.";
  readonly FailedToSaveToast: string = "Oops! Save process has failed. Please double-check your input and try again.";
  readonly receiveTypeToast: string = "Alert: Select Receive Type  to proceed.";
  readonly QtyCannotBeLessThenOneToast: string = "Error: The quantity cannot be less than 1.";
  readonly signInToast: string = "Sign-In Required: Please sign in to access.";
  readonly notAllowToast: string = "Sorry! You are not allowed to perform this action.";
  readonly selectMtoToast: string = "Alert: Select Make To Order number to proceed.";
  readonly offerQtyExceedToast: string = "Alert! Offer removed. Max offer qty exceeded.";
  readonly invalidInputToast: string = "Alert! Invalid input";
  readonly invalidDateToast: string = "Alert! Invalid Date";
  readonly invoiceDateLessthenToast: string = "Invoice date can't be before ";
  readonly invalidMobileToast: string = "Alert! Invalid mobile number";
  readonly invalidOTPToast: string = "Alert! Invalid OTP";
  readonly invalidThumbnailToast: string = "Alert! Thumbnail image is missing";
  readonly noOfImagesMustBeGivenToast: string = "Alert! Number of images must be given for customizable product.";
  readonly invalidRouteDetailsToast: string = "Alert! Invalid route details";
  readonly oldPasswordToast: string = "Alert! Old password is incorrect.";
  readonly selectEmailToast: string = "Alert! Select a sender email id from the list.";
  readonly pleseWaitToast: string = "Please wait: Your request is being processed. ";
  readonly sendRequestToast: string = "Alert! Send a request to fetch payment data.";
  readonly inadequateStokeQtyToast: string = "Insufficient Stock! Negative Qty is not allowed";
  readonly usedByOtherUserToast: string = "Oops! This is already in use by another user. Please try again later.";
  readonly productAddedToast: string = "Attention! This product is already added.";
  readonly maxGroupLimitToast: string = " Alert! Maximum limit of 99999 groups exceeded.";
  readonly surveyExpeiredToast: string = "Sorry, the survey you attempted to access has expired. ";
  readonly selectDeptToast: string = "Select Department";
  readonly selectProductToast: string = "Alert: Select a product to proceed with your request.";
  readonly selectBothProductAndLocationToast: string = "Alert: Select both product and location to proceed with your request.";
  readonly wastagepercentageToast: string = "Error: The wastage percentage must be greater than zero.";
  readonly conversionFactorToast: string = "Conversion Factor must be greater than 0";
  readonly convertedQtyToast: string = "Converted Quantity must be greater than 0";
  readonly productQtyMultipleToast: string = "Error: Product quantity must be a multiple of the lot size ";
  readonly cancelledInvoiceToast: string = "Cancelled Invoice cannot be edited";
  readonly commaNotAllowedToast: string = "Comma (,) is not allowed for ";
  readonly selectImgAndVideoToast: string = "Important! Please select an image or video file.";
  readonly selectProductionNoToast: string = "Alert: Select production number to proceed.";
  readonly selectOpeningBalanceTypToast: string = "Alert: Select customer opening balance type.";
  readonly CancelAdvancedSearchToast: string = "Advanced search disabled";
  readonly appointmentCheckedInToast: string = "Oops! Check-in for this appointment has already been completed.";
  readonly rateToast: string = "Error: The rate cannot be less than Rs.";
  readonly reasonForWastageToast: string = "Error: A reason must be given for all selected product(s).";
  readonly negativeRateToast: string = "Alert! Negative exchange rate is not allowed.";
  readonly customerGSTINToast: string = "Customer GSTIN is Mandatory";
  readonly changeQtyToast: string = "Change In qty is not permitted";
  readonly negativeValueToast: string = "Alert! Negative value is not allowed";
  readonly noVideoToast: string = "Important! Please Start Recording.";
  readonly shippingAlertToast: string = "User configuration Required in Notification Setup";
  readonly saveLastRow: string = "You must save the last row data before going to next row"
  readonly quantityMoreThanStock: string = "Insufficient Stock! Maximum quantity available";
  readonly paymentSetupNotAvailableToast: string = "Sorry, payment setup not available for this company.";

  //Singleused
  readonly actualCostToast: string = "Alert! Please enter the actual cost and actual time for this task.";
  readonly clearedAmountToast: string = "Attention! Please enter date & amount credited to bank";
  readonly selectCustomerToast: string = "Alert: Select customer to proceed.";
  readonly transactionFailedToast: string = "Payment Failed. Transaction cannot be completed at this time.";
  readonly fileSelectToast: string = "Alert: File selection required.";
  readonly selectPlaylistToast: string = "Alert: Select from playlist or provide URL to proceed.";
  readonly regeneratePinToast: string = "To regenerate your PIN code, click on the 'Edit' option";
  readonly appNotFoundToast: string = "Digi Board app not found";
  readonly cancelIsNotAllowedToast: string = "Cancelation is not allowed for this request";
  readonly issueQtyToast: string = "Enter Issue Quantity";
  readonly receiveQtyToast: string = "Enter Receive Quantity";
  readonly costingNotAvailableToast: string = "Costing for this product is not available";
  readonly selectIndentDeptToast: string = "Alert: Select department to proceed.";
  readonly departmentGivenToast: string = "Attention! Please select department for this request.";
  readonly productsIndentToast: string = "Alert: Add product(s) to proceed.";
  readonly selectConvertToast: string = "Alert: Select inventory type to proceed.";
  readonly chooseIndentDateToast: string = "Choose Indent Date";
  readonly selectIssueDateToast: string = "Alert: Select \"from issue date\" to proceed.";
  readonly selectIssueStockToast: string = "Alert: Select \"issue stock number\" to proceed.";
  readonly storeOutToast: string = "Alert: Select crate number to proceed.";
  readonly billTypeToast: string = "Alert: Select bill type to proceed.";
  readonly stokeNotAvailableToast: string = "No stock-in data available";
  readonly selectEditButtonToast: string = "Alert: Click on edit button to make changes.";
  readonly bankOpeningTypeToast: string = "Alert: Select Bank opening balance type.";
  readonly designationToast: string = "Attention! Please select designation for this request.";
  readonly openingBalanceTypeToast: string = "Alert: Select employee opening balance type.";
  readonly minimunOrderQtyToast: string = "The minimum order quantity must be greater than zero.";
  readonly selectFileToast: string = "Alert: Empty data found for previous file. Fill data to add more.";
  readonly downloardIsInProcessToast: string = "Please wait: The previous download is currently in progress.";
  readonly InvalidChannelToast: string = "Alert! Invalid Channel discount.";
  readonly empIdToast: string = "Attention! Please provide employee ID.";
  readonly supplierOpeningBalanceToast: string = "Alert: Select supplier opening balance type.";
  readonly DispatchNoToast: string = "Attention! Select a dispatch number to proceed.";
  readonly invalidReeceiveToast: string = "Please make sure to provide a valid remark in order to proceed with the return.";
  readonly orderProcessToast: string = "Alert: Select Order number(s) to proceed.";
  readonly selectDeptAndEmpToast: string = "Alert: Select department & employee to proceed.";
  readonly convertToUnitToast: string = "Alert: Select \"convert to unit\" to proceed.";
  readonly processFirstToast: string = "Alert: Select a product to proceed.";
  readonly daterangeToast: string = "Attention! The selected date range should fall within the financial year.";
  readonly OfferNotAvailableToast: string = "No offer is available at this moment";
  readonly creatingUserToast: string = "Please wait: System is creating the user for you. This may take a few moments.";
  readonly updatUserToast: string = "Please wait: System is updating the user for you. This may take a few moments.";
  readonly walletBalanceToast: string = "Error: The wallet balance cannot be greater than the usable wallet balance.";
  readonly EnterAmtandCustomerToast: string = "Attention! Please select customer enter amount.";
  readonly productNameToast: string = "Enter Valid Product Name";
  readonly customerEmailToast: string = "Customer email not found";
  readonly parkNotAllowedToast: string = "Payment is completed. Parking is not allowed after payment.";
  readonly addProductsToast: string = "Warning! You need to add a few products to proceed or close if you wish to continue later.";
  readonly CrNoteNotGenerateToast: string = "Insufficient Balance! Credit Note cannot be generated for Rs.0";
  readonly CouponNotGenerateToast: string = "Insufficient Balance! Coupon cannot be generated.";
  readonly offerRemovedToast: string = "Alert! Offer removed. Min offer qty is ";
  readonly frequencyTypeToast: string = "Alert: Costing data update frequency required. ";
  readonly returnAllowedToast: string = "Note: Return is allowed only for walk-in and delivery orders. Cancell the invoice instead of return.";
  readonly returnAllToast: string = "Success: Returned all products.";
  readonly customerMappedToast: string = "Customer is already mapped to another location";
  readonly NothingDawnloardToast: string = "There's no data to download at the moment.";
  readonly DeclinedToast: string = "Attention! The request has been declined.";
  readonly AssetToast: string = "no asset data was found";
  readonly gstInToast: string = "Alert! Invalid GSTN data";
  readonly panToast: string = "Alert! Invalid PAN data";
  readonly paymentSuccessToast: string = "Congratulations! Your payment was successful. ";
  readonly canNotPlaceOrdersToast: string = "Online orders are deactivated for your location.";
  readonly bookingExistToast: string = "Oops! It seems that a booking for this request already exists.";
  readonly NoEmployeeAvailableToast: string = "Alert! No employee found for this department.";
  readonly reserQtyToast: string = "Error: Quantity cannot be set to zero.";
  readonly senderEmailToast: string = "Error: Sender email data is not available. ";
  readonly receiverEmailToast: string = "Error: Receiver email data is not available. ";
  readonly whatsappToast: string = "Error: WhatsApp Setup Not Found.";
  readonly mobileAvailableToast: string = "Error: Receiver mobile is not available. ";
  readonly selectDeliveryCustomerToast: string = "Alert: Select customer to proceed to delivery.";
  readonly noDesignToast: string = "No design available for this product.";
  readonly customerAndservicemanToast: string = "Alert! Both customer and serviceman are mandatory.";
  readonly notrequiredToast: string = "Oops! Please provide the appointment number.";
  readonly deliveryDetailsToast: string = "Attention! Please provide your delivery details.";
  readonly procressToast: string = "Important! Please process before check-out.";
  readonly invalidPartyToast: string = "Oops! Please make sure you have either selected a customer or completed the payment process.";
  readonly invoiceCancelledToast: string = "The invoice has already been cancelled. ";
  readonly deliveryNotAvailableToast: string = "Delivery is not available for ";
  readonly checkPaymentToast: string = "Oops! No payment has been made for this shipment.";
  readonly deliveryNotAllowedToast: string = "Looks like you haven't started yet. Please press the 'Start' button to begin";
  readonly createUserFailedToast: string = "Failed To Create User";
  readonly servicemanToast: string = "Alert: Select a service-man to proceed.";
  readonly generateToast: string = " to generate.";
  readonly maxDiscountToast: string = "Violation: Breached max discount of ";
  readonly nameGivenToast: string = "Alert! No/Invalid Name";
  readonly whenMultipleLoginAttempt: string = "Another tab opens with the webpage you are currently accessing.";
  readonly minOrderAmountError: string = "The total order amount must exceed the minimum order amount.";
  readonly scheduleDateTimeError: string = "Alert! No/Invalid Schedule date and time";

  readonly offerExpiredToast: string = "Your selected order time offer has been expired, you can choose any new offer if available.";
  readonly timeOverlappingToast: string = "Time Overlapping is not allowed.";
  readonly toTimeMustBeEqualOrAfterFromTimeToast: string = "To time must be equal or after from time.";
  readonly toDateMustBeEqualOrAfterFromDateToast: string = "To date must be equal or after from date.";
  readonly redemptionQtyMustBeSmallerToast: string = "Redemption number must be smaller than number of coupons.";
  readonly discountMustBeEqualOrSmallerThan100: string = "Discount must be equal or smaller than 100.";
  readonly discountMustBeSmallerThan100: string = "Discount must be smaller than 100.";
  readonly getForValueMustBeSmallerToast: string = "Get for value must be smaller than selected product's net sale price.";
  readonly enterDiscPercentageOrForValueToast: string = "Please enter Discount Percent or Get For Value.";
  readonly scanningNotAvailableToast: string = "Scanning not available with pc.";
  readonly selectAtleastOneTimeslotToast: string = "Alert: Select atleast one timeslot to proceed.";
  readonly underWorkingToast: string = "Alert: This type report can't view right now.";
  readonly selectImageToast: string = "Alert: Please select a image file to send message.";
  readonly selectVideoToast: string = "Alert: Please select a video file to send message.";
  readonly selectPdfToast: string = "Alert: Please select a pdf file to send message.";
  readonly selectaFileToast: string = "Alert: Please select a file to send message.";
  readonly oneGridCanHaveVideoToast: string = "Alert: Only one grid can have video file playlist.";
  readonly oneGridCanHaveVideoForScheduleToast: string = "Alert: Only one grid can have video file playlist. Multiple video playlist addressed due to scheduled content no. ";
  readonly invalidInputToSearchCustomerToast: string = "Alert: Enter 10 digits of mobile number or 3 letters of name to search a customer.";
  readonly customerNotFoundToast: string = "Alert: Customer not found, please add customer details and save.";
  readonly fileNotFoundToast: string = "File not found";
  readonly invalidCouponToast: string = "Invalid Coupon, possible reasons: already redeemed, expired.";
  readonly dispatchQtyExeedToast: string = "Dispatch quantity must be equal or less than required quantity.";
  readonly specifyAllowWithCategoriesToast: string = "Alert: Please specify allow with categories.";



  //-------------SuccessToast------------
  readonly saveSuccessfullyToast: string = "Data has been successfully saved.";
  readonly deleteSuccessfullyToast: string = "Data has been successfully deleted.";
  readonly savedSuccessfullyWithModuleToast: string = "data has been successfully saved.";
  readonly saveChangesToast: string = "Changed saved.";
  readonly cancelSuccessfullyToast: string = "Cancellation successful.";
  readonly updateSuccessfullyToast: string = "Success! Data has been updated.";
  readonly updateedToast: string = " has been updated";
  readonly successToast: string = "Success! Invoice(s) have been generated.";
  readonly sendSuccessToast: string = "Success! Message sent. ";
  readonly statusUpdateToast: string = "Success! Status updated. ";
  readonly paymentRequestToast: string = "Pay through UPI request has been sent to your mobile.";
  readonly SmsToast: string = "Success! SMS sent to customer mobile number.";
  readonly approvedToast: string = "Your request has been approved";
  readonly processedToast: string = "This transaction has already been processed.";
  readonly checkedOutToast: string = "Check-out successful";
  readonly InvoiceToast: string = "Invoice No Updated";
  readonly OTPToast: string = " OTP has been sent to your registered mobile";
  readonly parkedToast: string = " has been Parked";
  readonly orderParkedToast: string = " Orders has been parked for dispatch";
  readonly ParkedToast: string = "Dispatch has been parked";
  readonly orderDispatchToast: string = " Orders has been Dispatched";
  readonly dispatchToast: string = " has been Dispatched";
  readonly orderCancelledToast: string = "order(s) have been successfully cancelled";
  readonly offerToast: string = "Offer added to cart.";
  readonly invoiceGeneratedToast: string = "Invoice Generated for Order No: ";
  readonly returnPackedToast: string = " return has been parked";
  readonly dispatchUpdateToast: string = "Order Dispatched: Dispatch updated for ";
  readonly fileRestoreTost: string = "File has been successfully restored."
  readonly fileBackupTosst: string = "File has been successfully backuped"
  readonly fullRestore: string = "Full Restore Completed"

  readonly dispatchedToStoreToast: string = "Order have been successfully dispatched to store.";
  readonly deliveredAtStoreToast: string = "Order successfully received at store.";
  readonly deliveredToCustomerToast: string = "Order have been successfully delivered to customer.";

  readonly returnedToParentToast: string = "Order have been returned to parent.";
  readonly returnReceivedAtParentToast: string = "Order have been return received parent.";

  readonly setupDuplicatedToast: string = "Setup has been successfully duplicated.";

  //single use
  readonly logoutToast: string = "Please wait: We are currently logging you out of your account.";
  readonly changePasswordToast: string = "Success! Your password has been changed.";
  readonly appointmentSaveToast: string = "Congratulations! Your appointment has been saved successfully.";
  readonly refundedToast: string = "Success! Amount has been refunded.";
  readonly canPlaceOrdersToast: string = "Online orders are now activated for your location.";
  readonly empImgToast: string = "Employee Image(s) Imported";
  readonly issueResolvedToast: string = "Issue Resolved";
  readonly imageUploadToast: string = "Image Uploaded";
  readonly linkSendToast: string = "The payment link has been sent successfully. ";
  readonly letsMeetToast: string = "Lets Meeting Successfully";
  readonly notificationToast: string = "Notification has been sent";
  readonly imageImportedToast: string = "Success! The product image has been imported.";
  readonly refaundToast: string = "Success: Refund has been initiated.";
  readonly requestraiseToast: string = "Success: Dispute request has been submitted.";
  readonly scheduleCreateToast: string = "Success: Schedule update created. ";
  readonly ClearCacheToast: string = "Oops! Something went wrong. Please clear your cache & try again.";
  readonly newNotificationToast: string = "You have a new Notification";
  readonly scheduledToast: string = "Scheduled has started.";
  readonly playlistToast: string = "Success! Your playlist data has been saved.";
  readonly manageContentToast: string = "Content has been assigned to screen.";
  readonly screenOnBoardingToast: string = "Success! Screen has been on-boarded.";
  readonly onBoardingCancelledToast: string = "Success! Screen has been de-boarded.";
  readonly updateAppToast: string = "Success! App update notification has been sent.";
  readonly stockIndentUpdateToast: string = "Success! Stock indent data has been updated.";
  readonly assignToast: string = "Success! Service-man has been assigned.";
  readonly appliedtocartToast: string = " has been applied to your cart";
  readonly OTPresentToast: string = " OTP has been resent to your registered mobile";
  readonly OTPverfiedToast: string = "Congratulations! Your OTP has been verified.";
  readonly declinedToast: string = " has been Declined";
  readonly storeInCreatedToast: string = "Success! Store-in has been created for ";
  readonly storeOutCreatedToast: string = "Success! Store-out has been created for  ";
  readonly deactiveToast: string = "Success! The user has been deactivated.";
  readonly passwordToast: string = "Success! Your password has been reset.";
  readonly suspendToast: string = "Success! User Suspended.";
  readonly unSuspendToastToast: string = "Success! User has been restored.";
  readonly activeToast: string = "Great News! Activation successful. Enjoy!";
  readonly setandAndActiveToast: string = "Your request for set password  has been submitted.";
  readonly resendmailToast: string = "Success! Activation mail resent. Please check your email for further instructions.";
  readonly sessionLogoutToast: string = "Success! Force logout complete.";
  readonly appUploadToast: string = "Congratulations! Your app has been successfully uploaded and be available soon.";
  readonly processToast: string = "Success: Order(s) have been processed.";
  readonly feedbackToast: string = "Congratulations!Thank you for taking the time to share your feedback.";
  readonly noShiftToast: string = "Alert! Select a shift";
  readonly shiftCreatedToast: string = "Success! Shifts have been created.";
  readonly appointmentAloowedToast: string = "visit with appointment is active now";
  readonly appointmentDesabledToast: string = "visit with appointment is inactive now";
  readonly customerAddressToast: string = "Customer Delivery Address Saved";
  readonly maintenanceUpdateToast: string = "Maintenance status updated";
  readonly driverToast: string = "Success! The driver data has been assigned";
  readonly vehicleSetToast: string = "Success! Vehicle data has been assigned.";
  readonly appointmentEditToast: string = "Edit Success! Your changes to appointment has been successfully edited.";
  readonly invoiceCancelToast: string = "Invoice Cancelled";
  readonly productionCostingToast: string = "Success! Product costing data has been saved.";
  readonly costingUpdateToast: string = "Please wait: System is updating costing data. This may take a few moments.";
  readonly autoInvoiceSaveToast: string = "Auto Invoice activated for location";
  readonly parkCancelledToast: string = " parked has been cancelled";
  readonly mixedItemNotAllowToast: string = "Invalid Selection: Mixing of taxable & zero-rated items is not allowed.";
  readonly confirmedToast: string = " has been confirmed";
  readonly createdToast: string = " has been created";
  readonly decimalValueNotAllowToast: string = "Invalid Entry: Decimal value not allowed for unit ";
  readonly duplicateCouponCode: string = "Duplicate coupon code detected."

  readonly gridTypeMismatchError: string = "Alert! Grid type mismatch detected on selected screens. You can manage new content.";
  readonly manageContentMismatchError: string = "Alert! Manage Content mismatch detected on selected screens. You can manage new content.";
  readonly scheduledContentMismatchError: string = "Alert! Scheduled Content mismatch detected on selected screens. You can manage new content.";

  readonly duplicateCompanySetupHeadingMessage: string = "Duplication Confirmation: Are you sure want to Duplicate.";

  //HeadingMessage

  readonly ItemRemove: string = "Item will be remove from playlist also";
  readonly PlaylistDeleted: string = "PlayList will be deleted";
  readonly CancelScreenOnboarding: string = "Screen OnBoarding will be Cancelled";
  readonly SaveData: string = "Are you sure want to save?";
  readonly UpdateData: string = "Are you sure want to Update?";
  readonly DeleteData: string = "Are you sure want to Delete?";
  readonly ConfirmOrder: string = "Are you sure want to Confirm Order?";
  readonly UpdateOrder: string = "Are you sure want to Update Order?";
  readonly ReceiveOrder: string = "Are you sure want to Recieve order";
  readonly ReturnOrder: string = "Would you like to Return?";
  readonly ProcessOrder: string = "Would you like to Process?";
  readonly ResetData: string = "All data will be reset";
  readonly ProductionChange: string = "Production type change should clear all data";
  readonly ScheduleProcess: string = "Would you like to Schedule next process";
  readonly CustomerDeboard: string = "Customer will be deboard";
  readonly DeleteSummary: string = "Summary Setup will be delete";
  readonly ResetCart: string = "Are you sure want to reset cart?";
  readonly NoDataSave: string = "No Data Shall Be Save";
  readonly CancelOrder: string = "Are you sure want to Cancel Order?";

  readonly webOrderConfirmationMessage: string = "You have a new order?";
  readonly CancelAppDevice: string = "App device will be deleted";
  readonly appDeviceCancelToast: string = "Success! App device has been deleted.";
  readonly backupConfirmation: string = "If there is any more backups?";

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////Info and Heading Message/////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  // admin/business-setup/bank-setup
  readonly BankSetUpForB2C: string = "Enter all the information about B2C Bank";
  readonly BankSetUpForB2B: string = "Enter all the information about B2B Bank";

  // admin/business-setup/business-setup
  readonly BussinessInformation: string = "Enter the basic information of the business";
  readonly GstInformation: string = "Enter the GST registration details of the company/business";
  readonly ReturnFillingFrequency: string = "Enter the interval in which your business will file the GST return";
  readonly InputTaxCreditAllow: string = "Enable/Disable input tax credit as per your business";
  readonly PrintSetup: string = "Attach the signature to be used and the different types of document to be printed in different sizes of papers";
  readonly TermsOfSale: string = "Enter the terms to be displayed at the bottom of the invoices as Terms";
  readonly DeclarationInvoice: string = "Enter any declaration to be displayed at the bottom of the page as a declaration";
  readonly FootNote: string = "Enter any specific message to be displayed at the end of the page as a footnote";
  readonly BankDetailsToPrint: string = "Enter the bank details of your business where the customer may deposit the payments. It will be displayed at the bottom of the invoices."
  readonly ImportBulkData: string = "Use this block to import records available in Excel format";
  readonly Latitude: string = "Latitude of the location";
  readonly Longitude: string = "Longitude of the location";
  readonly BusinessLegalName: string = "Registered name of the business";
  readonly NatureOfBusiness: string = "Enter the kind of business of your organization";

  //business-setup/online-payment-setup
  readonly UpiBankDetails: string = "Bank UPI Information to Receive the Different UPI Payments";
  readonly PaymentGatewayDetails: string = "Payment Gateway Information";

  readonly UPIId: string = "Enter the UPI ID shared by your bank";
  readonly MerchantId: string = "Enter the Merchant Id shared by your bank";
  readonly MerchantKey: string = "Enter the merchant key shared by the bank";
  readonly SwipeMachineId: string = "Enter the swipe machine machine ID given by the swipe machine provider";
  readonly SeceretKey: string = "Enter the seceret key given by the bank";
  readonly AccessCode: string = "Enter the access code given by the bank";
  readonly Url: string = "Enter the Url"

  //admin/transaction-setup/sale-cashregister-setup
  readonly SaleProductGroup: string = "Select the product groups to be displayed in the POS billing page";
  readonly SaleShippingTerm: string = "Enter the shipping terms to be displayed at the bottom of the invoices";
  readonly SalePaymentTerm: string = "Enter the payment terms to be displayed as Payment Terms at the bottom of the invoices";
  readonly PosTerm: string = "Enter the terms to be displayed at the bottom of the Point of Sale bills";
  readonly AllowNegativeQuantity: string = "Enable allow negative quantity when product available physically but not in software";
  readonly CouponExpiry: string = "Validity of the coupons after they are issued to the customer";
  readonly OrganiserDetails: string = "When enable organizer detail carry forward setup, the sequence of the organizer will be continued to the next day, otherwise it will start from 1 every day";
  readonly AutoRefund: string = "If enabled auto refund on cancel, it will initiate a refund process if the mode of payment is online";
  readonly DesignSetup: string = "This block will enable product designs to be displayed based on the selected product subgroups";
  readonly DeliveryTimeSlotSetup: string = "This block will used to enable delivery slots available for selected locations";
  readonly ShowImage: string = "If enabled it will show product group,subgroup and product images in POS billing screen";
  readonly ShowImageOrder: string = "If enabled it will show product matrix, group, subgroup and product images in Ordering screen";

  //admin/transaction-setup/maketoorder-setup
  readonly MTOProductGroup: string = "Select the product groups to display in the Make To Order (MOT) List";
  readonly DisplayOnThumbNail: string = "Select the information to be displayed along with the product image in the catalog page";
  readonly CustomizeType: string = "Set the options can be customized by/for the user";
  readonly CustomizeOrder: string = "Check if customized order allowed";
  readonly CustomizeOrderPrice: string = "Set the customize order price and other details";
  readonly MTOAutoProcess: string = "Set the system will automatically process the order or not, if then at what time and for which location";
  readonly AcceptOrderMinTime: string = "Enable accept order minimum time; if minimum time required to process the order is not necessary or quickly any order can be processed";
  readonly SpecialCustomizeProduct: string = "Enter the price for special mention on customized products";
  readonly MTORefund: string = "Allow auto refund the paid amount in case of make-to-order";
  readonly MTOTerms: string = "Enter the Terms for the make-to-order. It will be displayed in the make-to-order bill."
  readonly MTOPrint: string = "Specify the size of paper to be used in make-to-order Print";

  // admin/transaction-setup/inventory-setup

  readonly ProductSummary: string = "To view the inventories/components to be displated as preview while ordering the products";
  readonly StockTreatment: string = "select the check boxes corresponding to the different types of inventory where the quantity will be increased or decreased";

  // admin/transaction-setup/purchase-setup
  readonly PurchaseInvoice: string = "Enable the locations where your purchase invoice will be generated when goods delivered/received";
  readonly ShippingTerm: string = "Enter the shipping terms to be displayed in the purchase invoice";
  readonly PaymentTerm: string = "Enter the payment terms to be displayed in the purchase invoice";
  readonly PurchaseTerm: string = "Enter the purchase terms to be used in the purchase invoice";

  // admin/transaction-setup/ordermanagement-setup

  readonly OrderManagementProductGroup: string = "Set the product groups to be used while the locations ordered the goods";
  readonly CreditLimit: string = "set the credit limits, minimum order amount per location";
  readonly AutoProcessOrder: string = "set the orders will be automatically processed for the location or not";
  readonly VehicleTrackOrder: string = "set the assets to be tracked using LetsTrack if enabled with LetsTrack GPS devices";
  readonly DeliveryDepartment: string = "Set the department of which employees will be considered for delivery of goods";

  // admin/transaction-setup/account-setup

  readonly LeagerCreation: string = "Allow locations to create ledgers";
  readonly Autorefund: string = "set suto refund of payment if paid from unregistered source";
  readonly Autoreceipt: string = "Create payment receipt automatically when payment received from any registered party";
  readonly Costing: string = "Enable how product costing will be done automatically or manually";

  // admin/transaction-setup/billing-management-setup
  readonly Billingformation: string = "Set the type of invoicing, invoing from date, from time, etc.";
  readonly CouponCreditNote: string = "Set daily auto credit note generation to location for festival coupon redemptions";

  // admin/transaction-setup/resource-control-setup
  readonly QuerySetup: string = "Enter the number queryies that can be raised in case of any issues";
  readonly AgreementType: string = "Enter the types of agreements to be performed between franchises and locations";
  readonly LicenseType: string = "Enter the types of license to be performed between franchises and locations";
  readonly ContractType: string = "Enter the types of contracts that can be executed between parties";
  readonly PermitType: string = "Enter the types of permits required for the business";
  readonly InsuranceType: string = "Enter the types of insurances required for the businesses";
  readonly MaintainceType: string = "Enter the types of maintenance to be performed on the assets";

  // admin/transaction-setup/store-operation-setup
  readonly SelfUpdates: string = "Enter the parameters to measure the own activities";
  readonly StoreParticulars: string = "Enter the parameters to be used to measure the store operation";
  readonly StaffParticulars: string = "Enter the parameters to be used to measure the staff's performance";
  readonly TimeSlots: string = "Set the working time slots of the store staff";

  //////////////////////Admin->Transaction Setup->Security
  readonly GateType: string = "Enter name of the gates available";
  readonly VisitingDetails: string = "Enter the visitor's time period";
  readonly GateCheckSpecial: string = "Enter what to check at each gate before entry";
  readonly MaterialTiming: string = "Enter the material entry time allowed";
  readonly ProhibitionDetail: string = "Enter the item names not allowed inside the gates";


  //Hr
  readonly invalidForm: string = 'Invalid Form';
  readonly insufficientSelection: string = 'Insufficient selection to fetch data';
  readonly pageItemsSizeCommon: number = 11;
  readonly fractionalDecimal: number = 2;

  //PolicySetUp
  readonly maxCharacterSizeHr: number = 50;
  readonly empSetUpStatusList: string[] = ["All", "Active", "Inactive"];
  readonly appriasalByList: string[] = ['Self', 'Supervisor', 'Super Supervisor', 'HR Manager'];
  readonly statutoryTypeList: string[] = ['Fixed', '% of Basic'];
  readonly accomodationTypes: string[] = ['Free', 'Chargeable'];
  readonly facilityTypes: string[] = ["Finished", "Semi-Finished", "Core"];
  readonly benifitTypes: string[] = ["Asset", "Service"];
  readonly maintainceBy: string[] = ["Company", "Self"];
  readonly chargeableTypeList: string[] = ['fixed', 'percOfBasic'];

  readonly months = [
    { 'id': 1, 'name': 'January' },
    { 'id': 2, 'name': 'February' },
    { 'id': 3, 'name': 'March' },
    { 'id': 4, 'name': 'April' },
    { 'id': 5, 'name': 'May' },
    { 'id': 6, 'name': 'June' },
    { 'id': 7, 'name': 'July' },
    { 'id': 8, 'name': 'August' },
    { 'id': 9, 'name': 'September' },
    { 'id': 10, 'name': 'October' },
    { 'id': 11, 'name': 'November' },
    { 'id': 12, 'name': 'December' },
  ];
  readonly finacialYearCountSize: number = 4; // changed to 4 from 7 after testing
  readonly yearCountSize: number = 4; // changed to 4 from 7 after testing
  //Enrollment
  readonly unitOfClaimList: string[] = ['km', 'pcs', 'nos', 'unt', 'oth'];
  readonly empTypes: string[] = ['PartTime', 'FullTime'];
  readonly allocationTypeList: string[] = ["Dedicated", "Shared"];

  //Leave
  readonly leaveStatusList: string[] = ["Approved", "Declined", "Query"];

  //Expense
  readonly advExpenseStatusList: string[] = ["Approved", "Declined", "Query"];

  // Payroll
  readonly leaveEncashmentStatusList: string[] = ["Requested", "Approved", "Rejected", "Redeemed"];

  // account/expenses/hrExpenses
  readonly hrExpenseStatusList: string[] = ["Requested", "Approved", "Paid", "Rejected"];

  // Approval Status List
  readonly approvalStatusList: string[] = ["Requested", "Approved", "Cancelled"];

  // Exit Interview Status List
  readonly scheduleStatusList: string[] = ["Scheduled", "Completed", "Cancelled"];

  // attendance = new Map('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  readonly weekDaysList: Map<number, string> = new Map().set(0, 'Sunday').set(1, 'Monday').set(2, 'Tuesday')
    .set(3, 'Wednesday').set(4, 'Thursday').set(5, 'Friday').set(6, 'Saturday');
  readonly punchTypeList: string[] = ['In', 'Out'];
  readonly inAttendanceTypeList: string[] = ['Work From Home', 'Present', 'Absent'];
  readonly outAttendanceTypeList: string[] = ['Work From Home', 'Present'];
  readonly attendanceCorrectionStatusList: string[] = ["Initiated", "Approved", "Declined", "Query Raised", "Regularized", "Regularize Declined"];

  // Capital foods
  readonly allowedPagesForUserAccess: string[] = ['Dashboard', 'KDS', 'Returns', 'Stock'];
  readonly allowedProcessesForUserAccess: string[] = ['Incoming', 'Preparing', 'Packaging', 'Dispatch'];

  // file upload constant tags
  readonly queryLeaveFileUploadTag: number = 1001;
  readonly queryAdvanceExpenseFileUploadTag: number = 1002;
  readonly queryClaimExpenseFileUploadTag: number = 1003;
  readonly claimExpenseDetailFileUploadTag: number = 1004;
  readonly advForExpenseDetailFileUploadTag: number = 1005;
  readonly queryLoanUploadTag: number = 1006;
  readonly empPayrollDeductionFileUploadTag: number = 1007;
  readonly empPayrollIncomeTaxFileUploadTag: number = 1008;
  readonly employeeDocumentDetailFileUploadTag: number = 1009;
  readonly queryCorrectionFileUploadTag: number = 1010;
  readonly approveLoanDetailFileUploadTag: number = 1011;

  // project string values
  readonly maxAmtExceeds: string = 'Max amount exceeds'

  // string constants
  readonly currentUserHasNotLinkedWithUser: string = 'Current user has not linked with an employee';
  readonly noLoanSetupsAvailable: string = 'No Loans SetUp Available'
  readonly noRequestedLoansAvailable: string = 'No Loans Available for Approve'
  //////////////////////Admin->Transaction Setup->CRM Setup
  readonly AudienceType: string = "Enter the name of the different audiences to be participated in the surveys";
  readonly Assesment: string = "Set whether to display the correct answer after the assessment gets over or not";

  //////////////////////Admin->Transaction Setup->Web Order

  //Missing Some Info Option

  readonly PickupTimeSlot: string = "Select the pickup time slot during which the customer can pick up their order from the store."
  readonly InvoicingSetup = "Select either parent company or child company from where the invoice will be generated, and enable/disable 'stock check' option to check corresponding location's stock"
  readonly SetHomeDeliveryLocation: string = "Set the locations pincode from which the clients can place home delivery order on the selected website."
  readonly ChocolateGroupSetUp: string = "Select the product groups to be used for chocolates."
  readonly ProductDesignSetUp: string = "This block will enable product designs to be displayed based on the selected product subgroups on website"
  readonly ProductMessageSetup: string = "Select product subgroups where customers can write a personalized message at checkout which will be add on the product."
  readonly BestSellingProducts: string = "Select the products that are best selling products to be displayed in the first page"
  readonly BestSellingMakeToOrderProducts: string = "Select the products that are best selling make to order products to be displayed in the first page"
  readonly StoreSetup: string = "Select store locations to display on the store page of the selected website."
  readonly WebDomainDetails: string = "Set the domain details for selected website"
  readonly NotificationSetup: string = "Enable the 'Auto Confirm Order' option so that notification will be sent to the configured users and the order will be automatically confirmed after the order is placed by the customer."
  readonly WebDomainSetup: string = "Enter the website details along with other credentials to connect with the e-commerce engine";

  readonly ProductGroupSetup: string = "Select the product groups to be displayed in the selected website."
  readonly MakeToOrerGroupSetup: string = "Select the product groups to be displayed as Catalogue Cake in the selected website"
  readonly WhatToCustomize: string = "Enable/Disable the options to be displayed/hide while the customer selects any customized product on the selected website."
  readonly OrderValue: string = "Set the minimum order value for the selected website."
  readonly DeliveryCharge: string = "Set different types of delivery charges applicable on orders depending on order value range and a minimum order value in the selected website."
  readonly CareerSetup: string = "Enter the career details if there is any vacancy in your company."
  readonly FranchiseSetup: string = "Enter Location/City/State where you have any franchise opportunity."
  readonly PromotionProductSetup: string = "Select the products to be displayed in the first page of the selected url"
  readonly ReleventProducts: string = "Select the products that are relevant products to be displayed in the first page."
  readonly MinMaxTimeForOrder: string = "Set the minimum time before date of delivery and maximum time before date of delivery."
  readonly DeliveryTimeSlot: string = "Select the slots in which you are ready to deliver the products."
  readonly OfferPromotionSetup: string = "Allow all promotions and offers created to the web clients/users"
  readonly AggregatorSetup: string = "Enter Aggregator Details"
  readonly UserAccessSetup: string = "Enter User Access Details"
  readonly WebOrderCancelSetup: string = "Set the cancellation policies for web orders."
  readonly WebOrderRescheduleSetup: string = "Set the rescheduling policies for web orders."

  readonly SetStorePickupLocation: string = "Set the locations from which the clients can pickup the products once placed on the website."

  readonly PhotoCakeGroupSetUp: string = "Select the product groups to be used for photo cakes."
  readonly PhotoFramesSetup: string = "Select the product groups to be used for photo frames."
  readonly CaricatureSetup: string = "Select the product groups to be used for caricature"
  readonly CustomizeProductPrice: string = "Enter the values applicable for customize products."

  //Admin->Transaction Setup->Shipping & Delivery
  readonly SurgePay: string = "Set the different amount to be paid in different weather conditions if applicable at the time of delivery";
  readonly CustomSurgePay: string = "Set time surge pay If applicable";
  //Admin->Transaction Setup->Production Setup
  readonly ProductionMachineSetup: string = "Set the machines that are not usable, not available, or under maintenance so that they won't be used in production planning and scheduling";

  //Admin->Transaction Setup->B2B Setup
  readonly B2BProductGroup: string = "Set the product groups to be used in B2B Sales";
  readonly B2BMTOGroup: string = "Set the MTO Groups to be used in B2B Make To Order";
  readonly CustomizeDetails: string = "Select the fields to be used for B2B customized product order";
  readonly OfferDetail: string = "Enable the option Allow product offers to B2B customers if applicable";
  readonly TrackDetail: string = "Enable the option B2B Track if you allowed the B2B customers to track the orders";
  readonly cashOnDelivery: string = "Enable the cash on delivery option if required for the B2B customer."
  readonly designSetupForB2BCustomer: string = "Add the product subgroups where designs are applicable for the B2B customers."

  //Admin->Transaction Setup->Facilty Control Setup
  readonly ScheduleDetails: string = "Enter the different possible schedules to book the facilities available";
  readonly BookingDetails: string = "Enter different bookings for different locations";
  readonly MaterialDetails: string = "Select different materials required for the bookings";

  //admin/transaction-setup/google-api-key-setup
  readonly APiKey: string = "Enter the Google API Key details as required/specified";

  //admin/transaction-setup/Production Machine
  readonly ProductionMachine: string = "Select the machines available for production";

  //admin/transaction-setup/Platform
  readonly Restaurant: string = "Enter the name of the restaurant";
  readonly RestaurantLocation: string = "Assign locations to the restaurant";
  readonly RestaurantSwiggy: string = "Restaurant Swiggy setup";
  readonly RestaurantZomato: string = "Restaurant Zomato setup";

  //admin/communication-setup/kaizala-setup
  readonly KaizalaCredential: string = "Enter the Kaizala details as per the credentials available in the Kaizala site for communication";
  readonly ConnectorID: string = "Enter kaizal connection ID";
  readonly ConnectorSecret: string = "Enter the password of Kaizala";
  readonly UserToken: string = "Enter user token as per kaizal";
  readonly KaizalaSubScriber: string = "Select the locations where Kaizala is used";
  readonly CommunicationGroup: string = "Enter the Kaizala communication group names";

  //admin/communication-setup/aws-credential-setup
  readonly AWSCredential: string = "Enter all AWS credential details";
  readonly Bucket: string = "Enter the bucket name created in AWS site";
  //admin/communication-setup/communication-setup
  readonly CommunicationDetail: string = "Select the modules against which there will be email/whatsapp/fcm/kaizala communication to the different locations/customers";
  //admin/manage users/usergroup-setup
  readonly UserGroupSetup: string = "Enter a user group name and select the users groups you want to assign to it.";
  //admin/manage users/userrole-setup
  readonly ProductAccessSetup: string = "Enter a role matrix name and select the product sub-groups to which this role should have access.";
  //admin/manage users/userrole-setup
  readonly FunctionalAccessSetup: string = "To provide functional access to the submodule for selected users, enable the corresponding checkboxes";
  //admin/database setup
  readonly LocationDataBaseSetup: string = "Enable options which will be appear while creating a new location under master location setup";
  readonly SupplierDataBaseSetup: string = "Enable options which will be appear while creating a new supplier under master supplier setup";
  readonly ProductDataBaseSetup: string = "Enable options which will be appear while creating a new product under master product setup";
  readonly ServicemanDataBaseSetup: string = "Enable options which will be appear while creating a new serviceman under master serviceman setup";
  readonly EmployeeDataBaseSetup: string = "Enable options which will be appear while creating a new employee under master employee setup";
  readonly CustomerDataBaseSetup: string = "Enable options which will be appear while creating a new customer under master customer setup";
  //admin/app-setup/applications 
  readonly ApplicationSetup: string = "Add the application details to be displayed on your application's website."
  //admin/communication-setup/email-setup
  readonly EmailDetail: string = "Enter the sender email id, password, and server details from which the system will send the emails to the clients";
  readonly SenderEmail: string = "Enter sender eEmail id";
  readonly HostName: string = "Enter the host name or email provider SMTP server name or IP";
  readonly PortNo: string = "Enter the port used by the email provider to send the email";

  //admin/communication-setup/whatsapp-setup
  readonly WhatsAppDetails: string = "Enter the WhatsApp template details to be used for different types of communication";

  //admin/communication-setup/notification-setup
  readonly NotificationDetails: string = "Enter the different level of users responsible to handle the grievance as per your escallation matrix. The users will be communicated as per the schedule time."

  //admin/crm-setup/feedback-setup
  readonly GrievanceType: string = "Enter the type of grievances and the users as per the escallation matrix";
  readonly SubGrievanceType: string = "Enter sub grievance type name";
  readonly GrievanceDetail: string = "Enter grievance name";

  //admin/crm-setup/luckydraw-setup
  readonly SchemeSetup: string = "Enter the details of the scheme and the beneficiaries of the scheme";
  readonly PriceSetup: string = "Enter types of reward and no of clients will get the benefit";
  readonly CouponCriteria: string = "Enter coupon criteria applicable to the beneficiaries";
  readonly TermsForLuckyDraw: string = "Enter the terms applicable for the lucky draw";
  readonly RewardDetail: string = "Enter how the rewards will be distributed to the beneficiaries";
  readonly LuckyDrawCommunication: string = "Select the method of communication to the beneficiaries";
  readonly FeedBackCommunication: string = "Enter the type of grievance";

  ///Master Block Starts Here
  //admin/master/employee
  readonly EmployeeDetails: string = "Enter details of the employee";
  readonly EmployeeID: string = "Enter employee Id";
  readonly EmpStatutoryDetail: string = "Enter employee statutary details if any";
  readonly EmployeeCreditDetail: string = "Enter employee amount and period of credit if any as on date";

  //admin/master/region
  readonly RegionType: string = "Enter name of the regions where you have your business";
  //admin/master/city
  readonly CitySetup: string = "Enter the name of the city and select the district it belongs to.";

  //admin/master/area
  readonly AreaSetup: string = "Enter the name of the area and pincode, then select the city it belongs to.";

  //admin/master/location
  readonly LocationDetails: string = "Enter details of the location";

  //admin/master/floor
  readonly FloorSetup: string = "Enter name of the floor and select the location it belongs to";

  //admin/master/company
  readonly CompanyDetail: string = "Enter details of the companies associated with your business";
  readonly IndustrySubSegment: string = "Enter the industry subsegment details of the company";
  readonly CompanyAddress: string = "Enter company address details";
  readonly CompanyContact: string = "Enter the company contact person";
  readonly CompanyWebsite: string = "Enter the company website name if any";
  readonly CompanyTax: string = "Enter company tax registration details";
  readonly CompanyActivity: string = "Enter company activity details";
  readonly CompanyLocation: string = "Select the company's longitude and latitude from the map or search it";

  //admin/master/saleschannel
  readonly saleChannelDetails: string = "Enter the different sales channel the company used for its business";
  readonly saleChannelLocation: string = "Select the locations that will use this sales channel.";
  readonly LocationType: string = "Enter the different types of locations the company has";
  readonly LocationWeb: string = "Enter name of the website of the location";

  //admin/master/floor
  readonly FloorNameDetails: string = "Enter name of the floors the company used for it business";

  ///admin/master/storagepoint
  readonly StoragePointSetup: string = "Enter Name of the storage points and select the floor it belongs to";
  readonly StoragePoint: string = "Name of the storage points where the company keeps the goods";
  readonly StorageArea: string = "Enter the storage area available in square meters";
  readonly StorageSetup: string = "Enter the storage details and select the storage point it belongs to"
  // admin/master/Matrix
  readonly ProductMatrixSetup: string = "Enter the product matrix name and select inventory type it belongs to";
  readonly ProductMatrixType: string = "Enter the product matrix names";
  //admin/master/product group
  readonly ProductGroupSetupDetail: string = "Enter the product group name and select matrix type it belongs to";
  readonly ProductGroupType: string = "Enter the product group names";
  //admin/master/product sub group
  readonly ProductSubGroupSetup: string = "Enter the product sub group name and select group type it belongs to";
  readonly ProductSubGroupType: string = "Enter the product subgroup names";
  //admin/master/brand
  readonly BrandType: string = "Enter the different brand names";
  readonly ProductBrandSetup: string = "Add product brand names to be used when creating a new product."
  //admin/master/productbatch
  readonly BatchType: string = "Enter the different batch names";
  readonly ProductBatchSetup: string = "Add product batch names to be used when creating a new product."
  //admin/master/
  readonly ProductCompositionSetup: string = "Add product composition details to be used when creating a new product."
  readonly ProductCompositionType: string = "Enter different product compositions";
  //admin/master/class
  readonly CustomerClassSetup: string = "Add customer's class name to be used when creating a new customer."
  readonly CustomerClassType: string = "Enter different class of customers";
  readonly CustomerGSTIN: string = "Enter the customer's GST number, if they have GST";
  readonly OpeningBalance: string = "Enter the opening balance amount to be used as the starting point for calculations "
  readonly CreditLimitCustomer: string = "Enter the maximum credit amount allowed for the customer "
  //admin/master/supplier
  readonly SupplierSetup: string = "Enter name of the supplier associated with your business"
  //admin/master/crate
  readonly CrateInfo: string = "Enter the name of the crate that will be used during shipping."
  readonly CrateDescription: string = "Enter a description to specify the type of material that should be kept in this crate";
  //admin/master/coupon
  readonly CouponName: string = "Enter the name of the coupon."
  //admin/master/bank
  readonly BankCompany: string = "Select the companies to be associated with the entered account information."
  readonly BankLocation: string = "Select the locations to be associated with the entered account information."

  //admin/master/department
  readonly DepartmentSetup: string = "Add departments used in the company for the employees"
  readonly DepartmentType: string = "Enter different department names";
  //admin/master/designation
  readonly DesignationSetup: string = "Add designations used in the company for the employees";
  readonly DesignationType: string = "Enter different designations used in the company for the employees";
  //admin/master/job role
  readonly JobRoleSetup: string = "Add the job roles that will be available for assignment when new employees are created.";
  readonly JobRoleType: string = "Enter different job roles assigned to the employees";
  //admin/master/service man
  readonly ServiceManInfo: string = "Enter the employee name to be assigned as a serviceman in POS.";
  //admin/master/organiser-location
  readonly OrganiserLocationType: string = "Enter location of the organizer";
  readonly OrganiserLocationSetup: string = "Add location of the organizer";
  //admin/master/organiser-class
  readonly OrganiserClassType: string = "Enter class of the organizer";
  readonly OrganiserClassSetup: string = "Enter class of the organizer";
  //admin/master/organiser
  readonly OrganiserType: string = "Enter organizer name";
  readonly OrganiserTypeSetup: string = "Enter organizer name";
  //admin/master/organiser-details
  readonly OrganiserDetailsType: string = "Enter details of the organizer";
  readonly OrganiserDetailsTypeSetup: string = "Enter details of the organizer";
  //admin/master/route
  readonly RouteType: string = "Enter different route names passing through different locations with distance and arrival/departure time";
  //admin/master/process
  readonly ProcessType: string = "Enter different process names";
  ///admin/master/assets
  readonly AssetName: string = "Enter different asset available";
  readonly AssetLife: string = "Enter the life span of the asset in days";
  readonly PerfomanceCheck: string = "Enter performance check frequency";
  readonly AssetDetails: string = "Enter name of the assets";
  readonly TaxDetails: string = "Enter details of taxes paid on the asset";
  //admin/hardware setup/GPS
  readonly IMEINO: string = "Enter the asset's IMEI number for tracking purposes.";
  ///admin/master/product
  readonly ProductDetails: string = "Enter details of the products used in the company";
  readonly ProductThumbnailFiles: string = "Attached the product images to be used as thumbnails";
  readonly ProductHierrarchyDetails: string = "Select the product hierarchy to organize the products";
  readonly StorageDetails: string = "Select the storage where the product is available";
  readonly UnitQuantityDetails: string = "Enter the quantity details and different minimum levels for different type of sales";
  readonly ProductTaxDetails: string = "Enter the different taxes applicable on the product";
  readonly ProductPriceDetails: string = "Enter product price";
  readonly ProductDiscountDetails: string = "Enter maximum discount applicable on the product";
  readonly ProductReturnDetails: string = "Select return/exchange applicable on the product or not";
  readonly ProductCustomization: string = "Select product customization allowed or not; if yes, then how many images are required for customization while ordering the product";
  readonly ProductDisplayType: string = "Enter product name to be displayed on the screen";
  readonly ProductGenericType: string = "Enter generic name of the product if any";
  readonly ProductBarCodeType: string = "Enter product bar code if any";
  readonly ProductBatchCodeType: string = "Enter batch code of the product if any";
  readonly ProductShelfLife: string = "Enter the maximum life of the product";
  readonly ProductOpeningStock: string = "Enter the opening quantity of the product";
  readonly ProductReOrderLevel: string = "Enter the minimum quantity balance to be maintained";
  readonly ProductRetailRol: string = "Enter the minimum quantity balance to be maintained in retail sales";

  //admin/manage-user/users-setup
  readonly UserDetails: string = "Enter the user details, including user type as employee or outsider";
  readonly PermissionDetails: string = "Select the groups allowed to the user";
  readonly LocationAccessDetails: string = "Select the locations allowed to the user";
  readonly ProductAccessDetails: string = "Select the products the user will handle";


  readonly notAllowedToChangeLocationType: string = "Not allowed to modify this location type"
  readonly selectDuplicateCateFromCompany: string = "Please select a duplicate from company"
  readonly sourceAndTargetComapnyCannotBeSame: string = "Alert! Select a different company to duplicate with"
  readonly sourceAndTargetUserCannotBeSame: string = "Alert! Select a different user to duplicate with"
  readonly selectDuplicateUserFromCompany: string = "Please select a duplicate from user"

  //admin/manage-user/users-setup
  readonly RoleMatrix: string = "Enter a role name and select the product subgroups accessible by this role.";
  //Added For Discount Product
  readonly customerCanNotbeChanged: string = "Discount product detect:  Customer cannot be changed"
  readonly customerAlreadyExist: string = "Already customer exist you can't scan discount product for other customer."
  readonly discountProductCanNotbePark: string = "Discounted products cannot be parked: please checkout"
  readonly productsCanNotbeAddedtToCart: string = "Only discounted products or only regular products can be added to the cart: both cannot be added to the same cart."

  readonly returnNoAllowedForDiscountToast: string = "Discount product detect: Invoice can't be edit or cancel.";

  //Added For Place Web Order
  readonly webOrderPlacedToast: string = "Order has been placed successfully.";
  readonly canNotPlaceOrderToast: string = "You have logged in to a parent location. Cannot place order from this location.";
  readonly URL_DISPATCH_WEB_ORDER: string = "order/web-order/dispatch-to-store";
  readonly URL_RECEIVE_WEB_ORDER: string = "order/web-order/delivery-at-store";
  readonly returnToParentToast: string = " to retun.";

  readonly RWO_SI_TO_PI: string = "Receive Web Order (SI to PI)";
  readonly RWO_BOS_TO_PI: string = "Receive Web Order (BOS to PI)";
  readonly RWO_SI_TO_BOS: string = "Receive Web Order (SI to BOS)";
  readonly RWO_BOS_TO_BOS: string = "Receive Web Order (BOS to BOS)";
  readonly RWO_TAXABLE_RECEIPT_CHALLAN: string = "Receive Web Order (Taxable Receipt Challan)";
  readonly RWO_EXEMPTED_RECEIPT_CHALLAN: string = "Receive Web Order (Exempted Receipt Challan)";

  readonly AssignProductComposition: string = "Add and assign product composition details that will be associated with the product at the time of creation."

  //HR Info Button Details For policysetup
  readonly DocumentType: string = "Specify the name of the person or role authorized to sign on documents  and upload related document files that verify or authorize this signatory.";
  readonly DocumentUpdateSetUp: string = "Specify how often employees are required to update their submitted documents.";
  readonly DocumentSetUp: string = "Provide the document's name and assign it to an appropriate document type and choose Yes or No if it's mandatory.";
  readonly CompanyDocumentSetUp: string = "Specify the company document name(s) and upload the corresponding file(s) for record-keeping and compliance purposes.";
  readonly EmployeeDocumentSetUp: string = "Specify the employee document name(s) and upload the corresponding file(s) for record-keeping and compliance purposes.";
  readonly CompanyAndEmployeeDocument: string = "Specify document name(s) and upload the corresponding file(s), indicating that each requires signatures from both the company and the employee.";
  readonly StatutorySetup: string = "Specify the amount range credited to the mentioned statutory fund (e.g., EPF) and provide details of both employee and employer contributions.";
  readonly CompensationAndBenefits: string = "Enter details of the employee's compensation and benefits. Specify the pay head name, the percentage of basic salary or amount, enter deduction amount, mark whether any supporting documents are required, and provide remarks for clarity.";
  readonly Reimbursements: string = "Define reimbursement settings to manage employee payments, including pay head name, calculation, deductions, required documents, and remarks as per company policy.";
  readonly Perquisites: string = "Define perquisite settings to manage employee benefits, including pay head name, calculation, deductions, required documents, and remarks as per company policy.";
  readonly TaxSlab: string = "Enter  details of the tax slab range. From Amount is the lower limit, To Amount is the upper limit, and Tax Rate applies to this income.";
  readonly CessSlab: string = "Enter details of the cess slab range. From Amount (lower income limit) and To Amount (upper limit). Enter the Cess Rate (%) applied on the calculated tax.";
  readonly IncomeTaxSections: string = "Enter the Income Tax section details. Specify the Section Name (e.g., 80C, 80D) and the Maximum Deduction Amount allowed under this section.";
  readonly CutOffSchedule: string = "Specify cut-off details for final document submission, including the cut-off date and whether payroll should be adjusted if documents are not submitted on time.";
  readonly Deductionschedule: string = "Enter deduction details (Section, Category, Statutory Expense, Documents). These reduce the employee’s taxable income and help calculate correct TDS.";
  readonly JobDescription: string = "Enter detailed information for the job description, including roles, responsibilities, and key tasks. Ensure it corresponds to the Job Description Name.";
  readonly ShiftBreak: string = "Enter shift break details: specify Break Name, Break Start and End Time, and Break Grace Time in minutes (To avoid marking early/late). Select ‘Yes’ if the break should be deducted from total work duration.";
  readonly MarkAttendance: string = "Mark employee attendance as Full, ½, or ¼ day, specifying corresponding Late Coming and Early Going minutes to adjust work hours and payroll accurately.";
  readonly AttendanceConversion: string = "Specify conversion values for different attendance types. Enter the equivalent number of ¼, ½, or ¾ days for Full Day, ¾ Day, or ½ Day absences to calculate attendance accurately.";
  readonly MinimumTimeBetweenTwoPunche: string = "Specify the minimum time required in between two punches.";
  readonly ExpenseSetup: string = "Provide details for expense claims: define which employee groups can claim, maximum amount and days allowed, unit and rate for calculation, and specify if bills, GPS, attendance, advances, or clubbing are required.";
  readonly LeaveSetup: string = "Define leave policies: set yearly entitlements, applicable gender, required documents, approval rules, utilization limits, carry forward, encashment, clubbing, sandwich policy, consecutive leaves, auto-cancel, and assign approvers for proper leave management.";
  readonly PMSSetup: string = "Enter the name of the performance parameter. Provide a clear description explaining what it measures. Assign a weightage percentage to indicate how important this parameter is in overall performance evaluation.";
  readonly AccomodationSetup: string = "Enter the accommodation benefit name and type. Specify if it is chargeable with the amount, and indicate who is responsible for its maintenance.";
  readonly EmployeeGroup: string = "Specify the group name to categorize employees effectively.";
  readonly EncashmentCategory: string = "Specify the encashment category name, that determines how employee entitlements are processed for encashment.";
  readonly EncashmentAmount: string = "Specify the encashment amount applicable to this category as per company policy or rule.";
  readonly LoneSetup: string = "Configure the loan eligibility rules and approval conditions for employees. These settings define eligibility criteria, loan amount limits, interest rate, tenure, approval timeline, payroll adjustment options, collateral requirements, and gap restrictions between loans.";
  readonly ExistSetup: string = "Configure employee exit policies and control rules. These settings define eligible employee groups, exit processing method, mandatory interview requirements, and restrictions on payroll, expenses, leave, and loan applications after exit initiation.";
  readonly SignatorySetup: string = "Configure authorized signatories responsible for approvals and operational activities. Add the signatory name, designation, and assign operational responsibilities accordingly.";
  //HR Info Button Details For enrollment
  readonly AccomodationEnrollment: string = "Select the accommodation from the list to assign it to the selected employee based on availability and eligibility.";
  readonly FamilyEnrollment: string = "Provide the employee family details including name, relationship, occupation, contact number, and full address information.";
  readonly EducationEnrollment: string = "Enter the education details for the selected employee, including level of education, university, year of passing, specialization, and score.";
  readonly ExpereinceEnrollment: string = "Enter the experience details for the selected employee, including company name, city, designation, employment duration, and reason for leaving.";
  readonly StatutoryEnrollment: string = "Enter the statutory details for the selected employee, including the statutory name, assigned status, and corresponding value.";
  readonly ReferenceEnrollment: string = "Enter the reference details for the selected employee, including the reference person’s name, relationship with the employee, company name, and contact number.";
  readonly BGCEnrollmet: string = "Enter the background check (BGC) details for the selected employee, including BGC name (e.g., Address Verification, Employment Verification), date, reference number, and status(e.g., Verified, Pending,Active,etc).";
  readonly DocumentEnrollment: string = "Enter the document details for the selected employee, including document type, document name, document number, and validity date.";
  readonly LetterEnrollment: string = "Enter the letter details for the selected employee, including the type of letter and its name.";
  readonly SalaryEnrollment: string = "“Specify the employee’s payroll type, base salary, category, and encashment for salary processing.";
  readonly LeaveEnrollment: string = "Select the type of leave to assign to the selected employee.";
  readonly LoanEnrollment: string = "Select the type of loan to assign to the selected employee.";
  readonly ExpenseEnrollment: string = "Select the type of expense to assign to the selected employee.";
  readonly PerformanceEnrollment: string = "Select the type of performance to assign or apply for selected employee.";
  readonly FoodCouponEnrollment: string = "Select the food coupon to assign to the selected employee.";
  readonly KraEnrollment: string = "Select the job description from the list to define the selected employee’s roles, responsibilities, and work expectations within the organization.";
  readonly WeeklyOffEnrollment: string = "Select the days of the week that will be considered weekly holidays for employees."
  readonly AttendanceEnrollment: string = "Select the attendance type assign to the selected employee.";
  readonly ShiftEnrollment: string = "Select the shift to assign to the selected employee.";
  readonly OvertimeEnrollment: string = "Select the overtime type to assign to the selected employee.";
  readonly EMITable: string = "Generates and displays a detailed EMI schedule based on the entered tenure, outlining the principal, interest, and total payable amounts for each installment.";
  readonly LoanAmount: string = "Provide the loan amount corresponding to the selected loan setup.";
  readonly LoanTenure: string = "Provide the loan repayment period, in months, according to the selected loan setup.";
  readonly LoanDetails: string = "Loan details will be displays according to choosen loan."
  readonly WorkHandOver: string = "Specify your ongoing tasks and select the employee who will handle them during your leave to ensure smooth workflow.";
  readonly AttendanceRequest: string = "Select the type of attendance correction you want to request (e.g., Present, Absent, etc.)";
  readonly EmpolyeeEnrollment: string = "Create the employee by filling in all required details including personal information, job details, reporting manager, and credit information. Ensure all fields are accurate before submitting to successfully create the employee record.";
  readonly EmployeeReporting: string = "Select the supervisor to define the employee’s reporting authority and ensure proper approval, communication, and responsibility within the organization.";
  readonly EmployeeCreditDetails: string = "Enter the credit amount and credit period to define employee compensation, payment schedule, and ensure accurate payroll processing within the organization."
  readonly AssetAllocation: string = "Select the Asset Name and Allocation Type from the list to assign assets properly as Dedicated or Shared for the employee."
  //PayRoll Tooltip
  readonly OvertimeCalculation: string = "This table displays the overtime calculation details for the selected employee, including attendance, shift differences, overtime hours, rates, and total payable amount. Pre-shift overtime is not allowed.";
  readonly TaxDeduction: string = "Enter the deduction amount under the selected income tax section and upload the supporting document to apply and validate the tax deduction.";
  readonly TaxCalculation: string = "This table shows the detailed tax calculation for the selected employee, including salary, benefits, deductions, tax amounts, adjustments, and net payable amount for each month.";
  readonly ApproveOrRejectTaxDeduction: string = "Review the submitted deduction details and supporting documents to approve or reject the employee’s tax claim as per company and income tax guidelines.";
   //FileCOnversion
  readonly fileConversion: string = "Are you sure you want to convert the file?";

  readonly PackageName = "Enter a unique name for the package to identify it easily.";
  readonly ValidityPeriod = "Enter the total number of days the package will remain valid after activation.";
  readonly NoOfUsers = "Enter the maximum number of users allowed to access this package.";
  readonly GracePeriodInDays = "Enter the additional number of days allowed after expiry before deactivation.";
  readonly warningBeforeExpire = "Specify how many days before expiry a warning should be shown to users."
  readonly PackagePrice = "Enter the total price of the package before applying any discounts."
  readonly PackageCode = "Enter a unique code to identify this package internally."
  readonly MaxDiscount = "Enter the maximum discount percentage that can be applied to this package."

  isCommaSeparatorEnabled: boolean = true;
  quantityFormat: string;
  rateFormat: string;
  orderRateFormat: string;
  totalFormat: string;
  roundOffFormat: string;
  showCurrency: boolean = false;
  currencyCode: string = 'INR';
  flexibleDecimalFormat: string;
  mobilePosTotalFooterFormat: string = '1.1-1';
  setFormatFromStorage(persistenceService: LocalStorageService,) {

    this.isCommaSeparatorEnabled = persistenceService.get('isCommaSeparatorEnabled') === 'true';

    this.quantityFormat = persistenceService.get('quantityFormat') + "quantity";
    this.totalFormat = persistenceService.get('totalFormat');
    this.roundOffFormat = persistenceService.get('roundOffFormat');
    this.rateFormat = persistenceService.get('rateFormat')+"rate";
    this.showCurrency = persistenceService.get('showCurrency') === 'true';
    this.currencyCode = persistenceService.get('currencyCode');
    this.flexibleDecimalFormat = persistenceService.get('flexibleDecimalFormat');
    this.orderRateFormat = persistenceService.get('orderRateFormat');
  }
   
  // helper
  public getCurrencySymbol(code: string): string {
        // ✅ Currency (ONLY if enabled)
    if (this.showCurrency) {
    switch (code) {
      case 'INR': return '₹';
      case 'USD': return '$';
      case 'EUR': return '€'; 
      case 'GBP': return '£';
      case 'JPY': return '¥';
      case 'CNY': return '¥';
      case 'CAD': return 'C$';
      case 'AUD': return 'A$';
      case 'CHF': return 'Fr';
      case 'SGD': return 'S$';
      case 'AED': return 'د.إ';
      case 'SAR': return '﷼';
      case 'QAR': return '﷼';
      case 'KWD': return 'د.ك';
      case 'BHD': return '.د.ب';
      case 'OMR': return '﷼';
      case 'MYR': return 'RM';
      case 'THB': return '฿';
      case 'VND': return '₫';
      case 'PHP': return '₱';
      default: return code;
    }
  }
  }
} 
